import { createSelector } from '@reduxjs/toolkit';

import { OrderItemResponse } from '../../services/api/dto/SearchOrders';
import { RootState } from '../../types';

const detailedSelector = (state: RootState) => state.orderDetailed;
const sortsDirection = (state: RootState) => state.orderDetailed.sorts;

const filterByStatus = createSelector(detailedSelector, (state) => {
  const type = state.filters.status;
  if (state.data.order) {
    if (type === 'ALL') {
      return state.data.order.items;
    }
    return state.data.order.items.filter((item) => item.status === type);
  }
  return [] as OrderItemResponse[];
});

const filterByQuery = createSelector(
  [detailedSelector, filterByStatus],
  (state, filtered) => {
    const query = state.filters.search;

    if (query === '') {
      return filtered;
    }
    if (filtered.length > 0) {
      return filtered.filter(
        (item) => item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    }

    return filtered;
  }
);

const sortByPositions = createSelector(
  [filterByQuery, sortsDirection],
  (filtered, sorts) => {
    const { count, sum, positions } = sorts;

    let sorted = filtered;
    if (sorted.length > 0) {
      if (positions.active) {
        sorted = sorted.slice().sort((a, b) => {
          if (positions.direction === 'ASC') {
            if (a.positionCount < b.positionCount) {
              return 1;
            }
            if (a.positionCount === b.positionCount) {
              return 0;
            }

            return -1;
          }
          if (a.positionCount < b.positionCount) {
            return -1;
          }
          if (a.positionCount === b.positionCount) {
            return 0;
          }

          return 1;
        });
      }

      if (count.active) {
        sorted = sorted.slice().sort((a, b) => {
          if (count.direction === 'ASC') {
            if (a.totalCountItem < b.totalCountItem) {
              return 1;
            }
            if (a.totalCountItem === b.totalCountItem) {
              return 0;
            }

            return -1;
          }
          if (a.totalCountItem < b.totalCountItem) {
            return -1;
          }
          if (a.totalCountItem === b.totalCountItem) {
            return 0;
          }

          return 1;
        });
      }

      if (sum.active) {
        sorted = sorted.slice().sort((a, b) => {
          if (sum.direction === 'ASC') {
            if (a.price < b.price) {
              return 1;
            }
            if (a.price === b.price) {
              return 0;
            }

            return -1;
          }
          if (a.price < b.price) {
            return -1;
          }
          if (a.price === b.price) {
            return 0;
          }

          return 1;
        });
      }
    }

    return sorted;
  }
);

export { filterByStatus, filterByQuery, sortByPositions };
